



































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import MobileDetect from 'mobile-detect';

import type { PMSubPhase } from '@/models/pmsubphase';
import type { CompanySetting } from '@/models/companySetting';
import type { Tag } from '@/models/tag';

@Component({
    name: 'PMFilteringSetting',
})
export default class FilteringSetting extends Vue {
    @Prop() private subPhases: PMSubPhase[];
    @Prop() private selectedSubPhase: PMSubPhase;

    @Prop() private tags: Tag[];
    @Prop() private selectedTag: Tag;
    @Prop() private companySetting: CompanySetting;
    @Prop() private canResetFilter: boolean;

    @Prop() private showOnlyMyLessons: boolean;

    @Getter('utils/currentLocale') private currentLocale: string;

    private get isDesktop() {
        const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
        const md = new MobileDetect(window.navigator.userAgent);
        return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
    }

    get showOnlyMyLessonsCopy() {
        return this.showOnlyMyLessons;
    }

    // noinspection JSUnusedGlobalSymbols
    set showOnlyMyLessonsCopy(value: boolean) {
        this.$emit('showOnlyMyLessonsChanged', value);
    }

    get showEmptySubphases() {
        return this.$store.getters['knowledge/showEmptySubphases'];
    }

    set showEmptySubphases(value: boolean) {
        this.$store.commit('knowledge/setShowEmptySubphases', value);
    }

    get selectedSubPhaseCopy() {
        return this.selectedSubPhase;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedSubPhaseCopy(value: PMSubPhase) {
        this.$emit('subPhaseChanged', value);
    }

    get selectedTagCopy() {
        return this.selectedTag;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedTagCopy(value: Tag) {
        this.$emit('tagChanged', value);
    }
}
